import React from "react"

import Nav from "../components/Navigation"
import Footer from "../components/Footer.js"

import Background from "../img/creative-bg.png"
import MobileBackground from "../img/mobile-creative-bg.png"
import Overlay from "../img/overlay.png"

import "./style/Creative.css"

import { CreativeData } from "./data/CreativeData.js"
import { MediaData } from "./data/MediaData.js"

const Creative = () => {
    function gridder(data) {
        var allWorks = data,
            workList = [],
            works = []
        for (var i = 0; i < allWorks.length; i++) {
            if (i % 3 === 0 && i !== 0) {
                works.push(workList)
                workList = []
            }
            workList.push(allWorks[i])
        }
        works.push(workList)
        return works
    }
    function gridderTwo(data) {
        var allWorks = data,
            workList = [],
            works = []
        for (var i = 0; i < allWorks.length; i++) {
            if (i % 2 === 0 && i !== 0) {
                works.push(workList)
                workList = []
            }
            workList.push(allWorks[i])
        }
        works.push(workList)
        return works
    }
    return (
        <div>
            <div className="foundation">
                <Nav className="nav" />
                <img
                    src={Background}
                    alt="background"
                    className="creative-background"
                />
                <img
                    src={MobileBackground}
                    alt="background"
                    className="mobile-creative-background"
                />
                <div className="prog-footer">
                    <Footer />
                </div>
            </div>
            <div className="content">
                <div className="body">
                    <p>
                        From graphic design to UI/UX design, to photography, dance,
                        and digital illlustration, I am in love with all things
                        creative and visual.
                    </p>
                    <p>
                        I’ve been designing since my high school years, and I
                        continue to specialize in designing interfaces, brands,
                        logos, and more. I have also spent a few years here and there
                        as a freelance photographer as well as a dancer.
                    </p>
                </div>
                <div className="portfolio">
                    <div className="work">
                        <h2 className="work-title">MY CREATIVE WORK</h2>
                        <div className="img-grid">
                            <div className="row">
                                {gridder(CreativeData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="work logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(CreativeData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(CreativeData)[2].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(CreativeData)[3].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[2].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[3].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[4].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CreativeData)[5].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="company logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="projects">
                        <h2 className="work-title mobile">
                            MY MEDIA PORTFOLIO (COMING SOON)
                        </h2>
                        <div className="img-grid">
                            <div className="row">
                                {gridder(MediaData)[0].map((work) => {
                                    return (
                                        <div href={work.link} className="wrapper">
                                            <img
                                                src={work.image}
                                                className="image-no-blur"
                                                alt="company logo"
                                            ></img>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(MediaData)[1].map((work) => {
                                    return (
                                        <div href={work.link} className="wrapper">
                                            <img
                                                src={work.image}
                                                className="image-no-blur"
                                                alt="company logo"
                                            ></img>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="img-grid-mobile">
                            <div className="mobilemedia-row">
                                {gridderTwo(MediaData)[0].map((work) => {
                                    return (
                                        <div href={work.link} className="wrapper">
                                            <img
                                                src={work.image}
                                                className="image-no-blur"
                                                alt="company logo"
                                            ></img>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="mobilemedia-row">
                                {gridderTwo(MediaData)[1].map((work) => {
                                    return (
                                        <div href={work.link} className="wrapper">
                                            <img
                                                src={work.image}
                                                className="image-no-blur"
                                                alt="company logo"
                                            ></img>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Creative
